<template>
  <container-customer-master-view
    masterName="顧客"
    insertDataPageName="addon-eco-ship-container-customer-insert"
    viewPageName="addon-eco-ship-container-customer-view"
    summaryPageName="addon-eco-ship-container-customer-summary"
    @callDelete="callDelete"
    @callSearch="callSearch"
    @callFetchAll="callFetchAll"
    @callUpdateOrder="callUpdateOrder"
    @updateDisplayItems="updateDisplayItems"
    :data="data"
    :columns="columns"
    :editable="false"
    ref="basicMaster"
  >
  </container-customer-master-view>
</template>

<script>
import ContainerCustomerMasterView from "./ContainerCustomerMasterView";
import { DeviceInfoMixin } from "@/mixins";
import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("ecoShip");


export default {
  components: {
    ContainerCustomerMasterView,
  },
  mixins: [DeviceInfoMixin],
  data() {
    return {
      columns: [
        {
          displayName: "顧客企業名",
          inputType: "string",
          key: "name",
          searchable: true,
        },
        {
          displayName: "担当者",
          inputType: "string",
          key: "person_in_charge",
          searchable: true,
        },
        {
          displayName: "電話番号",
          inputType: "string",
          key: "tel",
          searchable: false,
        },
      ],
      data: [],
      storedSearchKeyword: "",
    };
  },
  watch: {
    onChangeWindowSize() {
      this.onResize();
    },
  },
  async created() {
    this.refreshData();
    this.onResize();
  },
  methods: {
    ...mapActions([
      "fetchContainerCustomers",
      "updateContainerCustomer",
      "deleteContainerCustomer",
      "updateContainerCustomerOrders",
    ]),
    updateDisplayItems(number) {
      this.displayItems = number;
    },
    async refreshData() {
      let payload = {};
      this.$vs.loading();
      let res = await this.fetchContainerCustomers(payload);
      this.$vs.loading.close();

      this.data = res.enterprise_container_customers;
    },
    async callFetchAll() {
      let payload = {};
      this.$vs.loading();
      let res = await this.fetchContainerCustomers(payload);
      this.$vs.loading.close();
      this.data = res.enterprise_container_customers;
      this.$refs.basicMaster.forceUpdateTable(this.data);
    },
    async callSearch(condition) {
      if (Object.prototype.hasOwnProperty.call(condition, "keyword"))
        this.storedSearchKeyword = condition.keyword;
      let payload = {};
      if (this.storedSearchKeyword)
        payload.query.name = this.storedSearchKeyword; // TODO: 検索の仕様確認
      this.$vs.loading();
      let res = await this.fetchContainerCustomers(payload);
      this.$vs.loading.close();
      this.data = res.enterprise_container_customers;
    },
    async callDelete(id) {
      let payload = {
        id: id,
      };
      this.$vs.loading();
      await this.deleteContainerCustomer(payload);
      this.$vs.notify({
        title: "データを削除しました。",
        color: "danger",
        iconPack: "feather",
        icon: "icon-check",
        position: "top-center",
      });
      this.$vs.loading.close();
      this.refreshData();
    },
    async callUpdateOrder(sortOrders) {
      this.storedSearchKeyword = "";
      let payload = {
        body: {
          sort_orders: sortOrders,
        },
      };
      this.$vs.loading();
      await this.updateContainerCustomerOrders(payload);
      this.$vs.loading.close();
      this.refreshData();
    },
    /**
     *  iPhone,iPadでのレフトメニュー表示制御.
     */
    onResize() {
      this.$nextTick(() => {
        if ( ["iPhone", "iPad"].includes( this.getDeviceInfo().deviceType )) {
          // iPhone, iPad はメニューを表示しない。
          this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", false);
          this.$store.dispatch("updateVerticalNavMenuWidth", "no-nav-menu");
        } else {
          this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
          this.$store.dispatch("updateVerticalNavMenuWidth", "default");
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
